import { useMemo } from "react";

const useCleanEditableText = (editableText?: string): string | null => {
  const cleanedText = useMemo<string | null>(() => {
    if (!editableText) return null;

    // 全角スペースを半角スペースに変換する
    // eslint-disable-next-line no-irregular-whitespace
    return editableText.replace(/　/g, " ");
  }, [editableText]);

  return cleanedText;
};
export default useCleanEditableText;
